(function () {
  'use strict';

  angular.module('app.instagramPostOverview', ['ui.router'])

    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('home.instagramPostOverview', {
          requireLogin: true,
          url: 'instagramPostOverview/:url/:relativepath',
          templateUrl: 'app/instagramPostOverview/index.html?app_v=deployDate',
          scope: {},
          data: {
            authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
            navMarker: ['instagramPostOverview', 'index']
          },
          controller: 'instagramPostOverviewCtrl',
          controllerAs: 'vm',
          params: {
              url: null,
              relativepath: null
          }
        })
    }]);
})();